export const GET_ONGOING_CHALLENGES = 'GET_ONGOING_CHALLENGES';
export const GET_PAST_CHALLENGES = 'GET_PAST_CHALLENGES';
export const GET_FUTURE_CHALLENGES = 'GET_FUTURE_CHALLENGES';
export const GET_ALL_CHALLENGES = 'GET_ALL_CHALLENGES';
export const GET_CHALLENGE_DETAIL_INFO = 'GET_CHALLENGE_DETAIL_INFO';
export const RESET_CHALLENGE_DETAIL_INFO = 'RESET_CHALLENGE_DETAIL_INFO';
export const GET_MY_CHALLENGES = 'GET_MY_CHALLENGES';
export const GET_CHALLENGE_PHOTOS = 'GET_CHALLENGE_PHOTOS';



// WEBPACK FOOTER //
// ./src/data/constants/challenges-constants.jsx